import React, { useContext, useEffect } from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import useWindowSize from '../../customHooks/useWindowSize';
import { t } from 'i18next';
import EmployeeContractTypeContext from '../../context/EmployeeContractTypeContext/EmployeeContractTypeContext';
import { CustomSelectComplex } from '../CustomSelectComplex/CustomSelectComplex';
import ContractorsContext from '../../context/ContractorsContext/ContractorsContext';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import ButtonGroupGrayCustom from '../Buttons/ButtonGroupGrayCustom';
import { Spinner } from 'reactstrap';
import PermanenceReportContext from '../../context/PermanenceReportContext/PermanenceReportContext';
import { useState } from 'react';
import { ButtonWhite } from '../Buttons/ButtonWhite';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext';
import { getTenantInfoByKey } from '../../helpers/helpers';

const PermanenceFilterModal = ({ showModal, setShowModal }) => {

    const { windowWidth } = useWindowSize();

    const fullscreen = windowWidth <= 576

    const { permanenceReportState, handleGetPermanenceReport } = useContext(PermanenceReportContext);
    const { reportFilter } = permanenceReportState;

    const { getContractEmployeeTypes, employeeContractTypeState } = useContext(EmployeeContractTypeContext);
    const { contractEmployeeTypes } = employeeContractTypeState;

    const { getContractors, contractorsState } = useContext(ContractorsContext);
    const { contractors } = contractorsState;

    const { accessOpeningState, getAccessOpenings } = useContext(AccessOpeningContext);
    const { accessOpenigs } = accessOpeningState;

    const { getAccessBuildings, accessBuildingState } = useContext(AccessBuildingContext);
    const { accessBuildings } = accessBuildingState;

    const [filter, setFilter] = useState(reportFilter);

    const contractEmployeeTypeOptions = contractEmployeeTypes.map(contractEmployeeType => ({ label: contractEmployeeType.description, value: contractEmployeeType.code }));
    const contractorsOptions = contractors.map(contractor => ({ label: `${contractor.contractor_name} - ${contractor.contractor_natural_id}`, value: contractor.contractor_id }));
    const accessBuildingsOptions = accessBuildings.map(accessBuilding => ({ label: `${accessBuilding.opening ? accessBuilding.opening.openingDescription + ' - ' : ''}${accessBuilding.buildingDescription} - ${accessBuilding.buildingCode}`, value: accessBuilding.buildingId }));

    const accessOpenigsOptions = accessOpenigs.map(accessOpenig => ({
        title: accessOpenig.descripcion,
        active: filter.opening_code.some(opening_code => opening_code === accessOpenig.codigo),
        onClick: () => handleAddOpening(accessOpenig.codigo)
    }));

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const haveAccessBuildings = getTenantInfoByKey('is_building');

    const haveSelectedAnOpening = filter.opening_code.length > 0;

    const showBuildingsSelect = haveAccessOpenings === true ? (haveAccessBuildings === true && haveSelectedAnOpening === true) : haveAccessBuildings === true;

    const handleChange = (name, value) => {
        setFilter({
            ...filter,
            [name]: value
        })
    }

    const handleAddOpening = (openingCode) => {
        const wasAdded = filter.opening_code.some(opening_code => openingCode === opening_code);
        if (wasAdded) {
            const newValue = filter.opening_code.filter(opening_code => opening_code !== openingCode);
            setFilter({
                ...filter,
                opening_code: newValue,
                buildings: [],
            })
            return
        }
        setFilter({
            ...filter,
            opening_code: [...filter.opening_code, openingCode],
            buildings: [],
        });
    }

    const handleSetFilter = () => {
        handleGetPermanenceReport({
            ...filter,
            search_text: '',
            reg_from: 1
        })
        setShowModal(!showModal);
    };

    const clean = () => {
        setFilter({
            ...filter,
            opening_code: [],
            contract_type: [],
            contractors: [],
            buildings: [],
        })
    }

    useEffect(() => {
        setFilter(reportFilter);
    }, [reportFilter])

    useEffect(() => {
        if (showModal === true) {
            getContractEmployeeTypes();
            getContractors();
            if (haveAccessOpenings === true) {
                getAccessOpenings(true);
            }
            if (showBuildingsSelect) {
                getAccessBuildings(true, filter.opening_code);
            }
        }
        // eslint-disable-next-line
    }, [showModal, filter.opening_code])

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={() => setShowModal(!showModal)}
            fullscreen={fullscreen}
            backgroundColor='var(--gray-50)'
        >
            <div className='d-flex flex-column justify-content-between h-100'>
                <div>
                    <div className='row'>

                        <div className="col d-block d-sm-none">
                            <i
                                type='button'
                                onClick={() => setShowModal(!showModal)}
                                className="fa-solid fa-arrow-left fs-3"
                            >
                            </i>
                        </div>
                        <div className="col">
                            <h5 className={`m-0 custom-h4 text-center text-sm-start fw-semibold`}>
                                {t('FILTERS')}
                            </h5>
                        </div>
                        <div className="col d-flex justify-content-end">
                            <i
                                type='button'
                                onClick={() => setShowModal(!showModal)}
                                className="fa-solid fa-xmark fs-3 d-sm-block d-none"
                            >
                            </i>
                        </div>
                    </div>

                    <div className='row row-cols-1 gap-3 mt-2'>
                        <div className="col">
                            <label
                                className="form-label blue-dark-text-two fw-semibold"
                                htmlFor="contractors"
                            >
                                {t('CONT')}
                            </label>
                            <CustomSelectComplex
                                options={contractorsOptions}
                                name={'contractors'}
                                placeholder={t('SELECT')}
                                isClearable={true}
                                value={contractorsOptions.filter(contractorsOption => filter.contractors.some(contractor => contractor === contractorsOption.value))}
                                onChange={(e) => handleChange('contractors', e === null ? [] : [e.value])}
                            />
                        </div>
                        <div className="col">
                            <label
                                className="form-label blue-dark-text-two fw-semibold"
                                htmlFor="contract_type"
                            >
                                {getTenantInfoByKey('hiring_modalities_name')}
                            </label>
                            <CustomSelectComplex
                                options={contractEmployeeTypeOptions}
                                name={'contract_type'}
                                placeholder={t('SELECT')}
                                isClearable={true}
                                value={contractEmployeeTypeOptions.filter(contractEmployeeTypeOption => filter.contract_type.some(contract_type => contract_type === contractEmployeeTypeOption.value))}
                                onChange={(e) => handleChange('contract_type', e === null ? [] : [e.value])}
                            />
                        </div>
                        {haveAccessOpenings === true && (
                            <div className="col">
                                <label
                                    className="form-label blue-dark-text-two fw-semibold"
                                    htmlFor="contract_type"
                                >
                                    {t('OPENINGS')}
                                </label>
                                {
                                    accessOpeningState.isFetching ?
                                        <Spinner />
                                        :
                                        <ButtonGroupGrayCustom options={accessOpenigsOptions} />
                                }
                            </div>
                        )}
                        {showBuildingsSelect && (
                            <div className="col">
                                <label
                                    className="form-label blue-dark-text-two fw-semibold"
                                    htmlFor="buildings"
                                >
                                    {t('BUILDING')}
                                </label>
                                <CustomSelectComplex
                                    options={accessBuildingsOptions}
                                    name={'buildings'}
                                    placeholder={t('SELECT')}
                                    isClearable={true}
                                    isMulti
                                    value={accessBuildingsOptions.filter(accessBuildingsOption => filter.buildings.some(building => building === accessBuildingsOption.value))}
                                    onChange={(options) => handleChange('buildings', options.map(option => option.value))}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="d-flex justify-content-sm-end mt-3 justify-content-center gap-4">
                    <div>
                        <ButtonWhite
                            onClick={clean}
                            className='text-dark shadow-none'
                        >
                            {t('ERASE')}
                        </ButtonWhite>
                    </div>
                    <div>
                        <ButtonBlue
                            onClick={handleSetFilter}
                        >
                            {t('APPLY')}
                        </ButtonBlue>
                    </div>
                </div>

            </div>
        </CustomModal>
    )
}

export default PermanenceFilterModal